import { defineStore } from 'pinia';

export const useLoadingIndicatorStore = defineStore('loading-indicator', {
  state: () => ({
    loading: new Set(),
    isLoadingAnything: false
  }),
  actions: {
    startLoading(loadingId) {
      this.loading.add(loadingId);
      this.isLoadingAnything = true;
    },
    finishLoading(loadingId) {
      this.loading.delete(loadingId);
      this.isLoadingAnything = this.loading.size > 0;
    },
    async awaitRequest(actionToAwait, id = null) {
      const loadingId = null === id ? window.crypto.randomUUID() : id;
      this.startLoading(loadingId);
      try {
        await actionToAwait();
      } finally {
        this.finishLoading(loadingId);
      }
    }
  }
});
